import { Stack, Card, Typography, useTheme } from '@mui/material';

import { SvgColor } from '../svg-color';
interface props {
  title?: string;
  value?: string;
  iconImg: string;
  workedFor?: string;
  width?: any;
  user?: boolean;
  onClickUserCard?: () => void;
}
const UserCard = ({ title, value, iconImg, workedFor, width, user, onClickUserCard }: props) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        borderRadius: '5px',
        mb: 2,
        ml: { xs: 1, md: 2 },
        width,
        cursor: 'pointer',
        justifyContent: 'space-between',
      }}
      onClick={onClickUserCard}
    >
      <Stack fontSize={15} fontWeight={700} sx={{ m: '12px 0px 10px 12px' }}>
        {title}
      </Stack>
      <Stack
        direction={'row'}
        justifyContent={'space-evenly'}
        mb={1}
        sx={{
          display: 'flex',
          alignItems: 'center',
          alignContent: 'center',
          width: '100%',
        }}
      >
        <Stack sx={{ width: user ? '40%' : '45%' }}>
          <Typography
            fontSize={user ? 20 : 12}
            sx={{ color: theme.palette.grey[600] }}
            fontWeight={600}
          >
            {workedFor ?? value}
          </Typography>
        </Stack>
        <Stack
          sx={{
            bgcolor: theme.palette.quaternary.lightBlue,
            width: 50,
            height: 50,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
          }}
        >
          <SvgColor
            src={`/assets/icons/card/${iconImg}.svg`}
            sx={{
              width: '30px',
              height: '30px',
              color: theme.palette.quaternary.navyBlue,
            }}
          />
        </Stack>
      </Stack>
    </Card>
  );
};
export { UserCard };
